declare global {
  interface Document {
    msHidden?: boolean;
    webkitHidden?: boolean;
  }
}

/** @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API */
const getVisibilityProps = ():
  ['hidden' | 'msHidden' | 'webkitHidden', string] | [undefined, undefined] => {
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    return ['hidden', 'visibilitychange'];
  }

  if (typeof document.msHidden !== 'undefined') {
    return ['msHidden', 'msvisibilitychange'];
  }

  if (typeof document.webkitHidden !== 'undefined') {
    return ['webkitHidden', 'webkitvisibilitychange'];
  }

  return [undefined, undefined];
};

export const getIsDocumentVisible = () => {
  const [hiddenProp] = getVisibilityProps();
  return hiddenProp ? !document[hiddenProp] : true;
};
